import client from '../config/AxiosConfig';

export const GetPlacesByMoment = async (momentName, weddingPlace) =>
  client.get('/importantMomentPlace/public/by-moment', {
    params: { momentName, weddingPlace }
  });
